export const locale = {
    "USER": {
        "SETTINGS": {
            "TITLE": "Настройки пользователя",
            "NOTIFICATIONS": "Показывать уведомления",
            "DISPLAY_DELETED": "Отображать удаленные данные",
        },
    }
}